
<template>
  <v-container fluid>
    <page-header>

      <template slot="title"> 
        Negociações 📊
      </template>

      <template slot="action">
        <div class="pr-5 d-flex justify-end" v-if="!$vuetify.breakpoint.smAndDown">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                color="black" text small dense class="mr-n1 title-financial btn-primary"
                v-bind="attrs"
                v-on="on"
              >{{filter_by_status.text}}<v-icon right>mdi-filter</v-icon></v-btn>                
            </template>
            <v-list>
              <v-list-item v-for="item in filter_options" :key="item.value" @click="setFilter(item)">
                <v-list-item-title>{{item.text}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <calendar-date-picker class="pt-2" @datePicked="handleDatePicked" :month_events="month_events" is_date_type_month/> -->
        </div>
      </template>

    </page-header>
    <default-card>

      <template slot="content"> 
        <div class="pr-5 d-flex justify-end" v-if="$vuetify.breakpoint.smAndDown">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                color="black" text small dense class="mr-n1 title-financial btn-primary"
                v-bind="attrs"
                v-on="on"
              >{{filter_by_status.text}}<v-icon right>mdi-filter</v-icon></v-btn>                
            </template>
            <v-list>
              <v-list-item v-for="item in filter_options" :key="item.value" @click="setFilter(item)">
                <v-list-item-title>{{item.text}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <calendar-date-picker class="pt-2" @datePicked="handleDatePicked" :month_events="month_events" is_date_type_month/> -->
        </div>
        
        <negotiation-table class="px-3" :filter_by_status="filter_by_status" :date_picked="date_picked" />
      </template>

      <template slot="actions"> 
      </template>

    </default-card>
    
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index'


export default {
  name: 'NegotiationList',
  components: {
    CalendarDatePicker: () => import ('../events_agenda/calendar/CalendarDatePicker.vue'),
    NegotiationTable: () => import ('./table/NegotiationTable.vue')
  },
  data() {
    return {
      filter_options: [
        { status: ['canceled_negociation'], text: 'Canceladas'},
        { status: ['in_negociation'], text: 'Negociando'},
        { status: ['filed'], text: 'Arquivadas'},
        { status: ['in_negociation', 'filed', 'canceled_negociation' ], text: 'Todos'}
      ],
      filter_by_status: { status: ['in_negociation'], text: 'Negociando' },
      date_picked: this.$dayjs().startOf('month').format('YYYY-MM-DD').toString(),
      month_events: []
    }
  },
  methods: {
    setFilter(data){
      this.filter_by_status = {...data}
    },
    handleDatePicked(e){
      this.date_picked = this.$dayjs(e).startOf('month').format('YYYY-MM-DD').toString()
    },
    // getMonthEvents(){
    //   Api.Event.index({all_months_with_event: true}).then(r=>r.data).then(d=> {
    //     this.month_events = d 
    //   })
    // },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    //this.getMonthEvents();
  },
}
</script>

<style scoped>

</style>